import React, { useEffect } from "react";
import _ from "lodash";
import oldPrice from "../config/old_price.json";
import newPrice from "../config/new_price.json";
const ENV = process.env.REACT_APP_ENV;

interface CalculatePowerPriceServiceProp {
  type: string;
  service: any;
  plan: string;
  area: string;
  month: number;
  kW: number;
  powerFactor: number;
  kWh: number;
  fuel_price: number;
  fuel_for_1kwh: number;
  fuel_under_11kwh: number;
  fuel_over_11kWh: number;
}

const log = (data: any) => {
  if (ENV !== 'production') {
    console.log(data);
  }
};

const lowPowerPlanWithoutFactorDate =
  process.env.REACT_APP_LOW_POWER_PLAN_WITHOUT_FACTOR_DATE;

const isEnableLowPowerPlanWithoutFactor =
  new Date() >= new Date(lowPowerPlanWithoutFactorDate!);

const calculateFee = (priceData: any, month: number, kW: number, powerFactor: number, kWh: number) => {
  log(["calculateFee", priceData, month, kW, kWh]);
  if (priceData.type === "basic") {
    if (kWh === 0) {
      if (isEnableLowPowerPlanWithoutFactor) {
        return _.round(kW * priceData.unit_price / 2, 2);
      }
      return _.round(kW * priceData.unit_price * (185 - powerFactor) / 100 / 2, 2);
    }

    if (isEnableLowPowerPlanWithoutFactor) {
      return _.round(kW * priceData.unit_price, 2);
    }
    return _.round(kW * priceData.unit_price * (185 - powerFactor) / 100, 2);
  }

  if (month >= 7 && month <= 9 && priceData.type === "summer") {
    return _.round(kWh * priceData.unit_price, 2);
  }

  if ((month < 7 || month > 9)&& priceData.type === "winter") {
    return _.round(kWh * priceData.unit_price, 2);
  }

  return 0;
};

const CalculatePowerPriceService = (props: CalculatePowerPriceServiceProp) => {
  log(props);
  let priceData = null;
  priceData = props.type === "old" ? oldPrice : _.get(newPrice, props.service);

  let reEnergyPrice = 0;

  // ReEnergyPrice
  const nowDate = new Date();
  _.forEach(priceData.re_energy_price, (row: any) => {
    if (
      nowDate.getTime() >= new Date(row.from).getTime() &&
      nowDate.getTime() <= new Date(row.to).getTime()
    ) {
      reEnergyPrice = row.price;
    }
  });
  log(["reEnergyPrice", reEnergyPrice]);

  // fuelPrice
  let fuelPrice = 0;
  if (props.fuel_price != 0) {
    fuelPrice = props.fuel_price
  }
  if (props.fuel_under_11kwh != 0 || props.fuel_over_11kWh != 0) {
    if (props.kWh <= 11) {
      fuelPrice = props.fuel_under_11kwh;
    } else {
      fuelPrice = _.toNumber(props.fuel_under_11kwh) + _.toNumber(props.fuel_over_11kWh * (props.kWh - 11));
    }
  }
  if (props.fuel_for_1kwh != 0) {
    fuelPrice = props.fuel_for_1kwh * props.kWh;
  }
  log(["fuelPrice", fuelPrice]);

  // Prices
  const planPrice = props.type === "old" ? priceData : _.get(priceData, props.plan);
  const areaPrice = _.get(planPrice.area, props.area);
  const prices = _.get(areaPrice, 'low_power');
  log(["prices", prices]);

  // Fees
  const fee0 = calculateFee(prices.price0, props.month, props.kW, props.powerFactor, props.kWh);
  const fee1 = calculateFee(prices.price1, props.month, props.kW, props.powerFactor, props.kWh);
  const fee2 = calculateFee(prices.price2, props.month, props.kW, props.powerFactor, props.kWh);

  const fuelFee = _.floor(fuelPrice, 2);
  const reEnergyFee = _.floor(reEnergyPrice * props.kWh);
  const basicFee = _.floor(fee0);
  const paidFee = _.floor(fee1 + fee2);
  const totalFee = _.floor(basicFee + paidFee + fuelFee + reEnergyFee);
  const totalYearFee = _.floor(totalFee * 12);

  log({
    fee0,
    fee1,
    fee2,
    basicFee,
    paidFee,
    fuelFee,
    reEnergyFee,
    totalFee,
    totalYearFee
  });

  return {
    basicFee,
    paidFee,
    fuelFee,
    reEnergyFee,
    totalFee,
    totalYearFee
  };
};

export default CalculatePowerPriceService;